import { makeStyles, createStyles } from '@material-ui/core/styles'

const whatsNewPageStyles = makeStyles((theme) =>
  createStyles({
    root: {
      paddingLeft: 60,
      paddingRight: 4,
      paddingBottom: 20,
      backgroundColor: theme.palette.components.newsBackground,
      [theme.breakpoints.down(769)]: {
        paddingLeft: 4,
      },
      [theme.breakpoints.up(1024)]: {
        paddingLeft: 0,
      },
    },
    backButton: {
      paddingLeft: theme.spacing(1),
      backgroundColor: theme.palette.paper.tertiary,
      '&:hover': {
        backgroundColor: theme.palette.paper.tertiary,
      },
    },
    backArrow: {
      height: 32,
      width: 32,
      border: `2px solid ${theme.palette.primary.headerText}`,
      borderRadius: '100%',
      marginRight: theme.spacing(1),
    },
    tagList: {
      textAlign: 'center',
      flex: '0 0 100%',
    },
    tagItem: {
      marginLeft: '8px',
      marginBottom: '0px',
      [theme.breakpoints.down(769)]: {
        marginBottom: 4,
      },
    },
    skeletonWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
    },
    chipSkeleton: {
      margin: '0px 16px',
      borderRadius: '16px',
    },
    title: {
      margin: '20px',
      alignSelf: 'center',
    },
    titleDivider: {
      borderTop: '2px solid',
      marginBottom: '20px',
      color:
        theme.palette.type === 'light'
          ? theme.palette.base.gray
          : theme.palette.base.white,
    },
    // article item page styles
    itemPageLayout: {
      paddingLeft: 55,
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'center',
        paddingLeft: '0px',
      },
    },
    pageBody: {
      padding: '30px',
      display: 'flex',
      flexDirection: 'column',
      justifyItems: 'center',
      alignItems: 'center',
      marginTop: '64px',
    },
    videoContent: {
      position: 'relative',
      height: 400,
      marginBottom: '20px',
      [theme.breakpoints.down('sm')]: {
        height: 300,
      },
    },
    videoPlayer: {
      borderRadius: '8px !important',
    },
    textContent: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      maxWidth: '1000px',
    },

    itemPageheader: {
      background: theme.palette.paper.tertiary,
      borderBottom: `1px solid ${theme.color.gray}`,
      position: 'sticky',
      top: '64px',
      zIndex: 1,
      padding: theme.spacing(0.5, 0, 0.5, 1),
      [theme.breakpoints.down('sm')]: {
        top: '56px',
      },
    },
    heroImageFoundation: {
      maxWidth: '1000px',
      width: '100%',
    },
    heroImageContainer: {
      /* Establish a fixed aspect ratio for the container */
      /* This is crucial for preventing layout shifts */
      position:
        'relative' /* Needed for absolute positioning of children if desired, but good practice */,
      width: '100%' /* Or a specific width */,
      // maxHeight: '563px',
      overflow:
        'hidden' /* Ensures content doesn't spill out if dimensions are slightly off */,
      lineHeight: 0,
      paddingBottom:
        '56.25%' /* Example: 16:9 aspect ratio (height / width * 100) */,
      /* If your image has a different aspect ratio, adjust this percentage accordingly.
     For example, for a 4:3 image, it would be (3/4)*100 = 75%.
     You can also use 'aspect-ratio: 16/9;' for modern browsers. */

      background:
        '#f0f0f0' /* Optional: A subtle background for the placeholder */,
      display: 'flex' /* Helps in centering content if needed */,
      justifyContent: 'center',
      alignItems: 'center',
      color:
        theme.palette.type === 'light'
          ? theme.palette.base.gray
          : theme.palette.base.white,
      borderRadius: theme.spacing(1),
    },
    heroImage: {
      verticalAlign: 'bottom',
      borderRadius: 8,
      width: '100%',
      /* Make the image fill its container while maintaining aspect ratio */
      position: 'absolute' /* Positions it within the heroImageContainer */,
      top: 0,
      left: 0,
      objectFit:
        'cover' /* Crops the image to fill the container without distortion */,
      /* object-fit: contain; would scale down the image to fit entirely, potentially leaving empty space */
      /* You might also consider adding a subtle transition for a smoother load effect */
      transition: 'opacity 0.3s ease-in-out' /* Example transition */,
      paddingBottom: 0,
      marginBottom: 0,
    },
    imagePlaceholder: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      maxWidth: '1000px',
      maxHeight: '563px',
      borderRadius: 8,
      backgroundColor: theme.palette.paper.secondary,
    },
    subtitleContainer: {
      margin: theme.spacing(1, 0),
      width: '100%',
      maxWidth: '1000px',
    },
    altTextContainer: {
      paddingRight: theme.spacing(2),
    },
    feedbackContainer: {
      textAlign: 'right',
    },
  }),
)

export default whatsNewPageStyles
